import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme=>({
    title:{
        backgroundColor: "white",
        color:"#585858",
        fontWeight: 600,
        fontFamily: 'sans-serif',
        letterSpacing: '0.1px',
        textAlign: 'center',
        transition: '0.4s ease-out',
        margin: 0,
        fontSize: "1.5rem",
        '@media (max-width:1200px)':{
            fontSize: "1.3rem",
        },
        '@media (max-width:992px)':{
            fontSize: "1.2rem",
        },
        '@media (max-width:768px)':{
            fontSize: "1.1rem",
        },
        '@media (max-width:576px)':{
            paddingTop: "4%",
            fontSize: "1rem",
            textShadow: '0px 0px 0px',
        },
    },
    contenedorDiv: {
        height: '60px',
        background: '#f5f6f7',
        borderRadius: '17px',
        borderBottom: '4px solid #207AB9',
        padding: '20px 30px 10px 30px',
        margin: '15px 0px 30px 0px',
        color: "#727272",
        lineHeight: '20px',
        fontWeight: '600',
        fontSize: "1.1rem",
        '@media (max-width:768px)':{
            fontSize: ".9rem",
            height: '75px'
        },
    },
    appIcon: {
        width: 60,
        height: 60,
    },
}));

